<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { Bold } from "ls/common/keyboardShortcuts";
import { BoldIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setBold()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :shortcut="Bold"
    :icon="BoldIcon"
    @click="run"
    @keydown.enter="run"
  >
    Bold
  </SuggestionListItem>
</template>
